import { Box, LinearProgress } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';
import { FileWithStatus } from '@/types/upload';
import { UploadStatusBadge } from '@/components/Upload/components/UploadComponents';
import { UploadStatusTabs } from '@/components/Upload/utils/uploadUtils';
import { UploadTestIds } from '@/enums/uploadTestIds.enum';

export const UploadHeaderProgress = ({
  uploadingFiles,
  overallProgress,
  completedFiles,
  failedFiles,
  openStatusModal,
}: {
  uploadingFiles: FileWithStatus[];
  overallProgress: number;
  completedFiles: FileWithStatus[];
  failedFiles: FileWithStatus[];
  openStatusModal: (filter: UploadStatusTabs) => void;
}) => {
  return (
    <>
      {uploadingFiles.length > 0 && (
        <>
          <Box
            sx={{
              color: 'text.secondary',
              fontSize: '0.875rem',
              minWidth: '36px',
              textAlign: 'right',
            }}
            data-testid={UploadTestIds.UploadOverallPercent}
          >
            {`${overallProgress}%`}
          </Box>
          <Box sx={{ width: '140px' }}>
            <LinearProgress
              variant='determinate'
              value={overallProgress}
              data-testid={UploadTestIds.UploadOverallProgress}
            />
          </Box>
        </>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginLeft: '8px', paddingRight: '8px' }}>
        {completedFiles.length > 0 && (
          <UploadStatusBadge
            count={completedFiles.length}
            variant='success'
            onClick={() => openStatusModal(UploadStatusTabs.SUCCESS)}
            icon={<CheckCircle fontSize='small' />}
            testId={UploadTestIds.UploadSuccessCount}
            ariaLabel='Filter to view successful uploads'
            tooltipText='Show successful uploads'
          />
        )}
        {failedFiles.length > 0 && (
          <UploadStatusBadge
            count={failedFiles.length}
            variant='error'
            onClick={() => openStatusModal(UploadStatusTabs.ERROR)}
            icon={<Error fontSize='small' />}
            testId={UploadTestIds.UploadErrorCount}
            ariaLabel='Filter to view failed uploads'
            tooltipText='Show failed uploads'
          />
        )}
      </Box>
    </>
  );
};
